import Image from '@tiptap/extension-image'
import Link from '@tiptap/extension-link'
import { Table, TableCell, TableHeader, TableRow } from '@tiptap/extension-table'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'
import { MermaidCodeBlock } from './extensions/MermaidCodeBlock'

export interface MarkdownEditorExtensionOptions {
  /** Off by default so content authored in the app keeps the behaviour it has always had. */
  tables?: boolean
}

// Read by both MarkdownEditor and the round-trip check so they cannot drift apart: a guard that
// silently validates a different pipeline than the one that saves stops firing when it is needed.
export const SOURCE_FIDELITY_EXTENSION_OPTIONS: MarkdownEditorExtensionOptions = { tables: true }

// Fresh instances per call — TipTap keeps per-editor state on extensions, and the round-trip
// check builds a throwaway editor alongside the visible one.
export function createMarkdownEditorExtensions({ tables = false }: MarkdownEditorExtensionOptions = {}) {
  return [
    StarterKit.configure({ codeBlock: false }),
    MermaidCodeBlock,
    Link.configure({ openOnClick: false }),
    Image,
    ...(tables ? [Table.configure({ resizable: false }), TableRow, TableHeader, TableCell] : []),
    Markdown,
  ]
}
